import { render, staticRenderFns } from "./OutstandingOrders.vue?vue&type=template&id=5f44d0db&"
import script from "./OutstandingOrders.vue?vue&type=script&lang=js&"
export * from "./OutstandingOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports